window.salesInvoiceDownloadFormatter = function(value, row) {
    let html = '';
    if (row.allow_download === true) {
        if (can('admin.invoices.download')) {
            html += '<a href="/admin/invoices/download/'+row.sales_invoice_id+'" data-disable-nprogress="true">';
            html += '<i class="fa fa-download"></i>';
            html += '</a>';
        } else if (can('admin.relations.invoices.download')) {
            html += '<a href="/admin/relations/show/invoices/download/'+row.sales_invoice_id+'" data-disable-nprogress="true">';
            html += '<i class="fa fa-download"></i>';
            html += '</a>';
        } else if (can('invoices.download')) {
            html += '<a href="/invoices/download/'+row.sales_invoice_id+'" data-disable-nprogress="true">';
            html += '<i class="fa fa-download"></i>';
            html += '</a>';
        }
    }
    return html;
}
